import React, { Dispatch, useEffect, useState } from 'react'
import { Modal, Button, Row, Col, Divider, Skeleton, Spin } from "antd"
import { DownloadOutlined, SendOutlined } from '@ant-design/icons'
import { getFileFromBucket } from '../../api/AWS/getFile'
import { LoadingOutlined } from "@ant-design/icons";
import "./editPhoto.css"
import { downloadPDF } from './downloadData';
import { pdf } from '@react-pdf/renderer';

function padTo2Digits(num: number) {
  return num.toString().padStart(2, '0');
}

function formatDate(date: Date) {
  if (date) {
    date = new Date(date)
    return (
      [
        padTo2Digits(date.getDate()),
        padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join('/') +
      ' ' +
      [
        padTo2Digits(date.getHours()),
        padTo2Digits(date.getMinutes()),
      ].join(':')
    );
  }
}

const PhotoModal = (props: {
  setModalPhoto: Dispatch<boolean>, photoModal: boolean, data: any | undefined, setSelectedData: Dispatch<any | undefined>, bpId: string | undefined,
}) => {
  const { setModalPhoto, photoModal, data, setSelectedData, bpId } = props
  const [image, setImage] = useState<Blob | undefined>(undefined)

  useEffect(() => {
    if (data)
      getImage()
  }, [data])

  const getImage = async () => {
    const file: any = await getFileFromBucket(data.photoId)
    if (file && file !== 403) {
      setImage(file)
    }
    return file
  }

  const handleDownload = async () => {
    let photos = await getImage();
    let blob = await pdf(downloadPDF([data], [photos])).toBlob()
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const url = window.URL.createObjectURL(blob)
    a.href = url;
    a.download = "BP " + bpId + ".pdf";
    a.click();
    window.URL.revokeObjectURL(url);
  }

  const handleSend = () => {
  }

  const FooterButton = () => (
    <Row className='modal-footer-row' justify='space-between'>
      <Col xs={10}>
        <Button onClick={() => handleDownload()} icon={<DownloadOutlined />} className='modal-footer-button'>Telecharger</Button>
      </Col>
      <Divider className='modal-divider' type="vertical" />
      <Col xs={10}>
        <Button onClick={() => handleSend()} icon={<SendOutlined />} className='modal-footer-button'>Partager</Button>
      </Col>
    </Row>
  )

  return (
    <Modal
      width={"90%"}
      open={photoModal}
      footer={null}
      onCancel={() => {
        setModalPhoto(false)
        setSelectedData(undefined)
        setImage(undefined)
      }}
    >
      <Row>
        <Col xs={24}>
          <h3 className='modal-title'>Plateau {data?.trayNumber}</h3>
        </Col>
        <Col xs={24}>
          <h5 className='modal-date'>Photo prise le {formatDate(data?.modifiedOn)}</h5>
        </Col>
        <Col xs={24} className='image-col'>
          {image ?
            <img style={{ objectFit: 'contain', width: "100%" }} alt="" className='modal-image' src={image as unknown as string ?? ""} />
            :
            <Spin indicator={<LoadingOutlined className='loading-icon' />}>
              <Skeleton.Image className='modal-image' style={{ height: '100%', width: '25rem' }} />
            </Spin>
          }
        </Col>
        <Col xs={24}>
          <FooterButton />
        </Col>
      </Row>
    </Modal>
  )
}

export default PhotoModal